import React, { useState } from 'react';

import Draggable from 'react-draggable';
import Paper, { PaperProps } from '@mui/material/Paper';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import styled from 'styled-components';

import CustomButton from '../../CustomViews/Elements/CustomButton';

import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';

import { ConfirmPaymentDialogModel } from '../../Models/Common/CustomViewsInterfaces';

import FormTextField from '../../CustomViews/Elements/FormTextField';

const CustomDialogContent = styled(DialogContent) <{ $showRemarksField?: boolean;}>`
    width: ${(props) => (props.$showRemarksField ? '30vw' : '20vw')};

    .formTextFieldContainer {
        margin: 20px 0px 0px 0px;
    }
`;

function DraggablePaperComponent(props: PaperProps) {
    const nodeRef = React.useRef<HTMLDivElement>(null);

    return (
        <Draggable
            nodeRef={nodeRef as React.RefObject<HTMLDivElement>}
            handle="#alert-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'} >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

const ConfirmPaymentDialog = (fieldProps: ConfirmPaymentDialogModel) => {
    fieldProps = { ...new ConfirmPaymentDialogModel(), ...fieldProps };

    //Use States
    let [remarks, setremarks] = useState<any>();

    //Variables

    const remarksProps = {
        name: 'reason',
        title: 'Reason',
        placeholder: 'Add reason here',
        fieldValue: remarks ?? "",
        type: 'text',
        multiline: true,
        hideLabel: true,
        rows: 2,
        errorMessages: [],
        handleOnChange: (selectedValue: any) => {
            setremarks(selectedValue);
        },
    };

    return <Dialog {...{
        PaperComponent: DraggablePaperComponent,
        open: fieldProps?.openDialog ?? false,
        onClose: () => {
            if(fieldProps?.handleClose) {
                fieldProps.handleClose();
            }
        },
        'aria-labelledby': "customized-dialog-title",
        'aria-describedby': "alert-dialog-description",
        TransitionProps: {
            onExited: () => {
                if(fieldProps?.handleClose) {
                    fieldProps.handleClose();
                }
            }
        },
    }} >
        <DialogTitle style={{ cursor: 'move' }} id="alert-dialog-title">Update Payment</DialogTitle>

        <CustomDialogContent $showRemarksField={fieldProps?.showRemarksField ?? false}>
            <DialogContentText id="alert-dialog-description">
                Are you sure you want to update payment for {fieldProps?.invoiceId ?? "this invoice"}.{"\n"}
                Continue?
            </DialogContentText>

            {fieldProps?.showRemarksField && <FormTextField {...remarksProps} />}
        </CustomDialogContent>

        <DialogActions>
            <CustomButton
                btnType={ButtonType.CANCEL_LIGHT}
                title='Close'
                onClick={(e: any) => {
                    e.preventDefault();
                    if(fieldProps?.handleClose) {
                        fieldProps.handleClose();
                    }
                }} />

            <CustomButton
                btnType={ButtonType.PRIMARY_NO_BG}
                title='Update Payment Now'
                onClick={(e: any) => {
                    if(fieldProps?.buttonAction) {
                        fieldProps.buttonAction(remarks);
                    }
                }} />
        </DialogActions>
    </Dialog >
}

export default ConfirmPaymentDialog;
